interface ProfileScanRecord {
  id: string;
  generationId?: string;
  status?: 'processing' | 'incomplete' | 'completed' | 'failed';
}

export function calculateProfileStatistics(
  scans: readonly ProfileScanRecord[],
  savedSessionIds: readonly string[],
  bookmarkedLessonIds: readonly string[],
) {
  const generatedLessons = new Set(
    scans
      .filter((scan) => scan.status === 'completed')
      .map((scan) => scan.generationId || scan.id),
  ).size;

  // Session saves and bookmarked lessons are distinct account-scoped records.
  const savedLessons = new Set([
    ...savedSessionIds.map((id) => `session:${id}`),
    ...bookmarkedLessonIds.map((id) => `bookmark:${id}`),
  ]).size;

  return { generatedLessons, savedLessons };
}
